<template>
<div class="page">
    <div class="tabs mb-5">
        <div class="tabs-header">
            <div
                :class="['tabs-header-item', { active: active_tab === 'active' }]"
                @click="active_tab = 'active'">
                Active Facilities
            </div>
            <!-- <div
                :class="['tabs-header-item', { active: active_tab === 'stats' }]"
                @click="active_tab = 'stats'">
                Facility Stats
            </div>
            <div
                :class="['tabs-header-item', { active: active_tab === 'archives' }]"
                @click="active_tab = 'archives'">
                Facility Archives
            </div> -->
        </div>

        <div class="tabs-content">
            <div v-if="active_tab === 'active'">
                <ActiveFacilitiesTab />
            </div>

            <div v-else-if="active_tab === 'retired'">
                <RetiredFacilitiesTab />
            </div>

            <div v-else-if="active_tab === 'archives'">
                <FacilityArchivesTab />
            </div>

            <div v-else>
                <FacilityStatsTab />
            </div>
        </div>
    </div>
</div>
</template>

<script>
import ActiveFacilitiesTab from "@/components/list-facilities-page/ActiveFacilitiesTab"
import FacilityArchivesTab from "@/components/list-facilities-page/FacilityArchivesTab"
import FacilityStatsTab from "@/components/list-facilities-page/FacilityStatsTab"
import RetiredFacilitiesTab from "@/components/list-facilities-page/RetiredFacilitiesTab"

export default {
    name: "list-facilities-page",

    components: {
        ActiveFacilitiesTab,
        FacilityArchivesTab,
        FacilityStatsTab,
        RetiredFacilitiesTab
    },

    data () {
        return {
            active_tab: "active",
            query_filter: null
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/pages/ListFacilitiesPage.vue